'use client';

import classNames from 'classnames';
import { HTMLAttributes } from 'react';

interface DatePickerProps extends Omit<HTMLAttributes<HTMLInputElement>, 'onChange'> {
  label: string;
  labelClassName?: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  helperText?: string;
  required?: boolean;
  disabled?: boolean;
  min?: string;
  max?: string;
  placeholder?: string;
  className?: string;
  containerClassName?: string;
}

const DatePicker = ({
  label,
  labelClassName,
  value,
  onChange,
  error,
  helperText,
  required = false,
  disabled = false,
  min,
  max,
  placeholder,
  className,
  containerClassName,
  ...inputProps
}: DatePickerProps) => {
  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <div className={classNames('form-control', containerClassName)}>
      <label className={classNames('label', labelClassName)}>
        <span className="label-text">{label}</span>
      </label>

      <div className="relative">
        <input
          type="date"
          value={value}
          onChange={handleDateChange}
          min={min}
          max={max}
          placeholder={placeholder}
          className={classNames(
            'input input-bordered',
            {
              'input-error': !!error,
            },
            className
          )}
          disabled={disabled}
          required={required}
          onClick={(e) => e.currentTarget.showPicker?.()}
          {...inputProps}
        />
      </div>

      {helperText && (
        <div className="mt-2 px-1 text-[14px] text-gray-500">{helperText}</div>
      )}

      {error && (
        <label className="label">
          <span className="text-error label-text-alt">{error}</span>
        </label>
      )}
    </div>
  );
};

export default DatePicker;
